// Home carrousel code
const scrollCheckElement = (container, buttonLeft, buttonRight) => {
	if (
		!(
			container.firstElementChild == null ||
			container.firstElementChild == "undefined" ||
			container.firstElementChild == ""
		)
	) {
		const scrollStart = container.scrollLeft - container.firstElementChild.offsetWidth * 0.5;
		const scrollEnd =
			container.scrollWidth -
			container.lastElementChild.offsetWidth * 0.5 -
			(container.scrollLeft + container.offsetWidth);
		const disabled = "disabled";
		if (scrollStart <= 0) {
			buttonLeft.classList.add(disabled);
			buttonRight.classList.remove(disabled);
		} else if (scrollEnd <= 0) {
			buttonRight.classList.add(disabled);
			buttonLeft.classList.remove(disabled);
		} else {
			buttonLeft.classList.remove(disabled);
			buttonRight.classList.remove(disabled);
		}
	}
};

const sliderScrollElement = (element, container) => {
	const direction = element.dataset.direction;
	const style = window.getComputedStyle(container);
	const gap = parseInt(style.getPropertyValue("--gap"));
	let scrollMove = container.firstElementChild.offsetWidth + gap;
	if (direction === "start") {
		scrollMove = container.firstElementChild.offsetWidth * -1;
	}
	container.scrollLeft += scrollMove;
};

const moveCarrouselActiveElement = (event, carrousel) => {
	if (window.innerWidth <= 1024) return; // Don't do anything on table and mobile
	event.preventDefault();
	let firstPosition = event.pageX;
	let move = 0;
	let start = false;
	const time = event.timeStamp;
	let isMove = setTimeout(function () {
		carrousel.removeEventListener("mousemove", _moveCarrousel, false);
		carrousel.removeEventListener("touchmove", _moveCarrousel, false);
	}, 200);

	const _moveCarrousel = (event) => {
		window.clearTimeout(isMove);
		move = firstPosition - event.pageX;
		firstPosition = event.pageX;
		carrousel.scrollLeft += move;
		carrousel.classList.add("drag");

		if (start == false) {
			start = true;
			carrousel.addEventListener("mouseleave", _leaveCarouselElement, false);
			carrousel.addEventListener("mouseup", _leaveCarouselElement, false);
			carrousel.addEventListener("touchmove", _leaveCarouselElement, false);
		}
	};

	const _leaveCarouselElement = (event) => {
		if (window.innerWidth <= 1024) return; // Don't do anything on table and mobile
		event.preventDefault();
		carrousel.classList.add("dragEnd");
		carrousel.classList.remove("drag");
		carrousel.removeEventListener("mousemove", _moveCarrousel, false);
		const childWidth = carrousel.querySelector("div").offsetWidth;
		const position = Math.round(carrousel.scrollLeft / childWidth);
		const style = window.getComputedStyle(carrousel);
		let gap = style.getPropertyValue("--gap");
		if (gap == "") {
			gap = 0;
		} else {
			gap = parseInt(gap);
		}
		let finalPosition;
		const timeCondition = time + 300 > event.timeStamp;
		if (timeCondition && move > 0) {
			finalPosition =
				position * childWidth + position * gap + (childWidth + gap);
		} else if (timeCondition && move < 0) {
			finalPosition =
				position * childWidth + position * gap - (childWidth + gap);
		} else {
			finalPosition = position * childWidth + position * gap;
		}
		carrousel.scrollLeft = finalPosition;
		carrousel.removeEventListener("mouseleave", _leaveCarouselElement, false);
		carrousel.removeEventListener("mouseup", _leaveCarouselElement, false);
		start = false;
	};

	carrousel.addEventListener("mousemove", _moveCarrousel, false);
	carrousel.addEventListener("touchmove", _moveCarrousel, false);
};

const isInViewportElement = (element) => {
	const rect = element.getBoundingClientRect();
	const height = element.offsetHeight;

	return (
		rect.top >= height * -1 &&
		rect.bottom <=
			(window.innerHeight + height ||
				document.documentElement.clientHeight + height)
	);
};

function initSliderElement() {
	let carrousel = document.querySelectorAll(".carrousel-slider");
	if (carrousel.length > 0) {
		carrousel.forEach((element) => {
			if (isInViewportElement(element)) {
				element.classList.remove("carrousel-slider");
				let arrows = element.querySelector(".arrows_ui"),
					buttonLeft = arrows.querySelector(".left-arrow"),
					buttonRight = arrows.querySelector(".right-arrow"),
					carrousel = element.querySelector(".box_ccu-carrousel");
				scrollCheckElement(carrousel, buttonLeft, buttonRight);
				carrousel.addEventListener(
					"scroll",
					function () {
						scrollCheckElement(carrousel, buttonLeft, buttonRight);
					},
					false
				);
				carrousel.addEventListener(
					"mousedown",
					function (event) {
						moveCarrouselActiveElement(event, carrousel);
					},
					false
				);

				carrousel.addEventListener(
					"touchmove",
					function (event) {
						moveCarrouselActiveElement(event, carrousel);
					},
					false
				);

				let isScrolling;
				carrousel.addEventListener(
					"scroll",
					function () {
						window.clearTimeout(isScrolling);
						isScrolling = setTimeout(function () {
							carrousel.classList.remove("dragEnd");
						}, 66);
					},
					false
				);

				buttonLeft.addEventListener(
					"click",
					function () {
						sliderScrollElement(buttonLeft, carrousel);
					},
					false
				);
				buttonRight.addEventListener(
					"click",
					function () {
						sliderScrollElement(buttonRight, carrousel);
					},
					false
				);
			}
		});
	}
}

function triggerQuickAdd(){
    $(".plus-icon").click(function (event) {
        event.stopPropagation();
        $(this).parents(".card-wrapper").addClass("plus-clicked");
        this.closest('.card-wrapper')?.querySelector('.overlay-variant-radios')?.classList.remove('hidden');
    });

    $(".overlay-variant-radios").click(function(event) {
        event.stopPropagation();
        this.closest('.card-wrapper')?.querySelector('.overlay-variant-radios')?.classList.add('hidden');
        this.closest('.card-wrapper')?.classList.remove('plus-clicked');
    })
}

addEventListener("scroll", function () {
	initSliderElement();
	triggerQuickAdd();
});

addEventListener("touchmove", function () {
	initSliderElement();
});

addEventListener("DOMContentLoaded", function () {
    triggerQuickAdd();
});


const slideshowElement = document.querySelectorAll(".slideshow");
slideshowElement.forEach((element) => {
	if(!element) return;
	element.addEventListener(
		"mousedown",
		function (event) {
            moveCarrouselActiveElementElement(event, element);
		},
		false
	);
	let isScrolling;
	element.addEventListener(
		"scroll",
		function () {
			window.clearTimeout(isScrolling);
			isScrolling = setTimeout(function () {
				element.classList.remove("dragEnd");
			}, 66);
		},
		false
	);
});
